// MAG BAG — hero-drawable.js
// Chalk-textured drawing + animated deciduous tree on load

(function () {
  'use strict';

  var canvas = document.getElementById('hero-canvas');
  var clearBtn = document.getElementById('hero-clear');
  if (!canvas) return;

  var drawing = false;
  var last    = { x: 0, y: 0 };
  var ctx;
  var W, H;

  function init() {
    var r   = canvas.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    W = r.width;
    H = r.height;
    canvas.width  = W * dpr;
    canvas.height = H * dpr;
    ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
  }

  // ── Chalk primitives ─────────────────────────────────────────
  function chalkLine(x1, y1, x2, y2) {
    var dx   = x2 - x1, dy = y2 - y1;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (dist === 0) return;
    var nx = dx / dist, ny = dy / dist;
    var steps = Math.max(1, Math.floor(dist / 1.5));
    ctx.lineCap = 'round';
    for (var i = 0; i < steps; i++) {
      var t = i / steps;
      var px = x1 + dx * t, py = y1 + dy * t;
      var n = 2 + Math.floor(Math.random() * 3);
      for (var j = 0; j < n; j++) {
        var perp = (Math.random() - 0.5) * 5;
        var jx = px + (-ny * perp) + (Math.random() - 0.5) * 1.5;
        var jy = py + ( nx * perp) + (Math.random() - 0.5) * 1.5;
        var dashLen = 1.5 + Math.random() * 5;
        ctx.globalAlpha = 0.5 + Math.random() * 0.45;
        ctx.lineWidth   = 0.5 + Math.random() * 1.2;
        ctx.strokeStyle = '#FFFFFF';
        ctx.beginPath();
        ctx.moveTo(jx, jy);
        ctx.lineTo(jx + nx * dashLen, jy + ny * dashLen);
        ctx.stroke();
      }
    }
    ctx.globalAlpha = 1;
  }

  // ── Animation helpers ─────────────────────────────────────────
  function animatePoints(pts, speed, onDone) {
    var idx = 0;
    function next() {
      if (idx < pts.length - 1) {
        chalkLine(pts[idx].x, pts[idx].y, pts[idx + 1].x, pts[idx + 1].y);
        idx++;
        setTimeout(next, speed || 13);
      } else if (onDone) {
        onDone();
      }
    }
    next();
  }

  // Sample a quadratic bezier into n points
  function qBez(x1, y1, cpx, cpy, x2, y2, n) {
    var pts = [];
    for (var i = 0; i <= n; i++) {
      var t = i / n, mt = 1 - t;
      pts.push({
        x: mt*mt*x1 + 2*mt*t*cpx + t*t*x2,
        y: mt*mt*y1 + 2*mt*t*cpy + t*t*y2
      });
    }
    return pts;
  }

  // ── Deciduous tree ────────────────────────────────────────────
  // Shape: wide trunk splitting into Y, large bumpy crown
  function animateTree() {
    setTimeout(function () {

      // 1 — left trunk edge: flares wide at base, narrows to split
      animatePoints(qBez(W*.44,H*.87, W*.44,H*.73, W*.46,H*.62, 18), 11, function () {

        // 2 — right trunk edge (mirror)
        animatePoints(qBez(W*.56,H*.87, W*.56,H*.73, W*.54,H*.62, 18), 11, function () {
          setTimeout(function () {

            // 3 — left branch curves up-left into crown base
            animatePoints(qBez(W*.46,H*.66, W*.37,H*.61, W*.28,H*.56, 16), 11, function () {

              // 4 — right branch curves up-right
              animatePoints(qBez(W*.54,H*.66, W*.63,H*.61, W*.72,H*.56, 16), 11, function () {
                setTimeout(function () {

                  // 5 — bumpy crown, traced clockwise from the top
                  var cx = W*0.50, cy = H*0.38;
                  var rx = W*0.23, ry = H*0.18;
                  var samples = 96;
                  var crown = [];
                  for (var i = 0; i <= samples; i++) {
                    var a    = (i / samples) * Math.PI * 2 - Math.PI / 2;
                    var bump = 1 + 0.14 * Math.pow(Math.cos(9 * a), 2);
                    crown.push({
                      x: cx + Math.cos(a) * rx * bump,
                      y: cy + Math.sin(a) * ry * bump
                    });
                  }
                  animatePoints(crown, 10, null);

                }, 80);
              });
            });
          }, 80);
        });
      });
    }, 500);
  }

  // ── Input helpers ─────────────────────────────────────────────
  function pos(e) {
    var r = canvas.getBoundingClientRect();
    var t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  }

  // ── Mouse ─────────────────────────────────────────────────────
  canvas.addEventListener('mousedown', function (e) {
    e.preventDefault(); drawing = true; last = pos(e);
  });
  canvas.addEventListener('mousemove', function (e) {
    if (!drawing) return;
    e.preventDefault();
    var p = pos(e);
    chalkLine(last.x, last.y, p.x, p.y);
    last = p;
  });
  canvas.addEventListener('mouseup',    function () { drawing = false; });
  canvas.addEventListener('mouseleave', function () { drawing = false; });

  // ── Touch ─────────────────────────────────────────────────────
  canvas.addEventListener('touchstart', function (e) {
    e.preventDefault(); drawing = true; last = pos(e);
  }, { passive: false });
  canvas.addEventListener('touchmove', function (e) {
    if (!drawing) return;
    e.preventDefault();
    var p = pos(e);
    chalkLine(last.x, last.y, p.x, p.y);
    last = p;
  }, { passive: false });
  canvas.addEventListener('touchend', function () { drawing = false; });

  // ── Clear ─────────────────────────────────────────────────────
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    });
  }

  init();
  window.addEventListener('resize', init);
  animateTree();
})();
